/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const enum Role {
  MSP_PANEL_ADMIN = "MSP_PANEL_ADMIN",
  MSP_ADMIN = "MSP_ADMIN",
}
